const translations = {
  fr: {
    // Header
    search: "Rechercher",
    searchPlaceholder: "Rechercher un produit...",
    cart: "Panier",
    wishlist: "Favoris",
    profile: "Profil",
    logout: "Déconnexion",
    login: "Se connecter",
    freeBooster: "BOOSTER GRATUIT",
    myCart: "Mon panier",
    emptyCart: "Votre panier est vide",
    total: "Total",
    checkout: "Commander",
    continueShopping: "Continuer vos achats",
    freeShippingFrom: "Livraison gratuite dès 100€ d'achats",
    searchResults: "résultat",
    searchResults_plural: "résultats",
    noSearchResults: "Aucun résultat pour",
    firstVisit: "Première visite ?",
    // Products
    addToCart: "Ajouter au panier",
    addedToCartToast: "ajouté au panier",
    soldOut: "Épuisé",
    viewAll: "Tout voir",
    explore: "Explorer",
    inStock: "En stock",
    outOfStock: "Épuisé",
    stockLimited: "Stock limité",
    // Product Detail
    relatedProducts: "Produits similaires",
    addedToCart: "Ajouté !",
    quantity: "Quantité",
    customerReviews: "Avis clients",
    writeReview: "Donner mon avis",
    noReviews: "Aucun avis pour le moment.",
    loginToReview: "Connectez-vous pour laisser un avis.",
    yourReview: "Votre avis",
    rating: "Note",
    shareExperience: "Partagez votre expérience...",
    publish: "Publier",
    cancel: "Annuler",
    sending: "Envoi...",
    reviewUpdated: "Avis mis à jour",
    reviews: "avis",
    noReviewYet: "Aucun avis",
    shippingIn48h: "Expédition sous 48h",
    productNotFound: "Produit non trouvé",
    backToHome: "Retour à l'accueil",
    category: "Catégorie",
    categoryFeatured: "Vedette",
    categoryLatest: "Nouveauté",
    categoryJapanese: "Japonais",
    categoryChinese: "Chinois",
    // Category
    sort: "Trier par",
    sortDefault: "Par défaut",
    sortNewest: "Nouveautés",
    sortPriceAsc: "Prix croissant",
    sortPriceDesc: "Prix décroissant",
    sortName: "Nom (A-Z)",
    filters: "Filtres",
    priceRange: "Fourchette de prix",
    availability: "Disponibilité",
    allProducts: "Tous les produits",
    clearFilters: "Effacer les filtres",
    noProducts: "Aucun produit trouvé",
    productsFound: "produits trouvés",
    categoryNotFound: "Catégorie introuvable",
    categoryEmpty: "Cette catégorie est vide pour le moment",
    // Auth
    loginTitle: "Connexion",
    registerTitle: "Créer un compte",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    confirmPassword: "Confirmer le mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    orRegister: "Pas encore de compte ?",
    orLogin: "Déjà un compte ?",
    resetPassword: "Réinitialiser votre mot de passe",
    resetPasswordSuccess: "Mot de passe réinitialisé !",
    resetPasswordInvalid: "Ce lien de réinitialisation est invalide ou a expiré.",
    goToLogin: "Se connecter",
    newPassword: "Nouveau mot de passe",
    // Home sections
    latestProducts: "Nos dernières nouveautés",
    joinUs: "Rejoignez-nous",
    joinUsDesc: "Découvrez l'univers",
    onYouTube: "sur YouTube",
    visit: "Visiter",
    faq: "FAQ",
    collectEmotion: "Collectionnez l'Émotion",
    flashSales: "Ventes Flash",
    flashSalesDesc: "Offres limitées, ne manquez pas !",
    collectionPremium: "The Collectors Hub",
    discover: "Découvrir",
    heroDesc: "Booster & Starter, Display Japonais, Coffret exclusif... Trouvez votre prochain trésor TCG",
    boosterFree: "1 Booster offert !",
    boosterFreeDesc: "Pour votre première commande",
    claimOffer: "Réclamer mon booster",
    ourLivesWhatnot: "Nos Lives Whatnot",
    whatnotDesc: "Rejoignez nos ventes en direct sur",
    whatnotCta: "Voir nos lives",
    trustService: "Service Client Dédié",
    trustServiceDesc: "Réponse sous 24h",
    trustShipping: "Livraison Rapide",
    trustShippingDesc: "Expédié sous 48h",
    trustSponsoring: "Parrainage",
    trustSponsoringDesc: "5€ offerts pour chaque ami",
    // Profile
    myProfile: "Mon profil",
    personalInfo: "Informations personnelles",
    myAddresses: "Mes adresses",
    myOrders: "Mes commandes",
    security: "Sécurité",
    loyalty: "Fidélité",
    loyaltyProgram: "Programme fidélité",
    perEuroSpent: "par 1€ dépensé",
    perReview: "par avis publié",
    pointsToDiscount: "points = 1€ de réduction",
    noAddresses: "Aucune adresse enregistrée",
    addressSaved: "adresse enregistrée",
    addressSaved_plural: "adresses enregistrées",
    defaultAddress: "Par défaut",
    ordersWillAppear: "Vos commandes apparaîtront ici",
    // Checkout
    firstName: "Prénom",
    lastName: "Nom",
    address: "Adresse",
    addressComplement: "Complément d'adresse",
    city: "Ville",
    postalCode: "Code postal",
    country: "Pays",
    phone: "Téléphone",
    securePayment: "Paiement 100% sécurisé",
    orderSummary: "Récapitulatif",
    subtotal: "Sous-total",
    discount: "Réduction",
    promoCode: "Code promo",
    applyPromo: "Appliquer",
    pay: "Payer",
    qty: "Qté",
    // Order Confirmation
    paymentVerification: "Vérification du paiement...",
    orderConfirmed: "Commande confirmée !",
    amountPaid: "Montant payé",
    // Recently viewed
    recentlyViewed: "Vus récemment",
    // Compare
    compare: "Comparer",
    compareProducts: "Comparer les produits",
    price: "Prix",
    type: "Type",
    status: "Statut",
    available: "Disponible",
    clearAll: "Tout effacer",
    // Footer
    newsletter: "Newsletter",
    newsletterDesc: "Recevez nos offres exclusives",
    subscribe: "S'abonner",
    aboutUs: "À propos",
    aboutLinks: ["Notre histoire", "Blog", "Actualités", "Contactez-nous"],
    infoTitle: "Informations",
    infoLinks: ["CGV", "Mentions légales", "CGU", "Politique de confidentialité", "Politique de retour"],
    customerService: "Service client",
    quickLinks: "Liens rapides",
    followUs: "Suivez-nous",
    allRightsReserved: "Tous droits réservés",
    yourEmail: "Votre email",
    footerLinks: ["Confidentialité", "CGV", "Livraison", "Contact"],
    language: "Français",
    // Currency
    currency: "Devise",
    currencyLabel: "France (EUR €)",
    // Misc
    loading: "Chargement...",
    error: "Erreur",
    back: "Retour",
    apply: "Appliquer",
    save: "Enregistrer",
    delete: "Supprimer",
    close: "Fermer",
    min: "Min",
    max: "Max",
    newsletterPopupTitle: "Inscrivez-vous et recevez un",
    newsletterPopupSubtitle: "sur votre 1ère commande.",
    newsletterPopupDesc: "Abonnez-vous à notre newsletter et soyez les premiers informés de nos nouveautés, promotions et exclusivités.",
  },
  en: {
    // Header
    search: "Search",
    searchPlaceholder: "Search for a product...",
    cart: "Cart",
    wishlist: "Wishlist",
    profile: "Profile",
    logout: "Log out",
    login: "Log in",
    freeBooster: "FREE BOOSTER",
    myCart: "My Cart",
    emptyCart: "Your cart is empty",
    total: "Total",
    checkout: "Checkout",
    continueShopping: "Continue shopping",
    freeShippingFrom: "Free shipping on orders over €100",
    searchResults: "result",
    searchResults_plural: "results",
    noSearchResults: "No results for",
    firstVisit: "First visit?",
    // Products
    addToCart: "Add to cart",
    addedToCartToast: "added to cart",
    soldOut: "Sold out",
    viewAll: "View all",
    explore: "Explore",
    inStock: "In stock",
    outOfStock: "Sold out",
    stockLimited: "Limited stock",
    // Product Detail
    relatedProducts: "Related products",
    addedToCart: "Added!",
    quantity: "Quantity",
    customerReviews: "Customer reviews",
    writeReview: "Write a review",
    noReviews: "No reviews yet.",
    loginToReview: "Log in to leave a review.",
    yourReview: "Your review",
    rating: "Rating",
    shareExperience: "Share your experience...",
    publish: "Submit",
    cancel: "Cancel",
    sending: "Sending...",
    reviewUpdated: "Review updated",
    reviews: "reviews",
    noReviewYet: "No reviews",
    shippingIn48h: "Ships within 48h",
    productNotFound: "Product not found",
    backToHome: "Back to home",
    category: "Category",
    categoryFeatured: "Featured",
    categoryLatest: "New",
    categoryJapanese: "Japanese",
    categoryChinese: "Chinese",
    // Category
    sort: "Sort by",
    sortDefault: "Default",
    sortNewest: "Newest",
    sortPriceAsc: "Price: Low to High",
    sortPriceDesc: "Price: High to Low",
    sortName: "Name (A-Z)",
    filters: "Filters",
    priceRange: "Price range",
    availability: "Availability",
    allProducts: "All products",
    clearFilters: "Clear filters",
    noProducts: "No products found",
    productsFound: "products found",
    categoryNotFound: "Category not found",
    categoryEmpty: "This category is empty for now",
    // Auth
    loginTitle: "Sign in",
    registerTitle: "Create account",
    email: "Email",
    password: "Password",
    name: "Name",
    confirmPassword: "Confirm password",
    forgotPassword: "Forgot password?",
    orRegister: "Don't have an account?",
    orLogin: "Already have an account?",
    resetPassword: "Reset your password",
    resetPasswordSuccess: "Password reset!",
    resetPasswordInvalid: "This reset link is invalid or has expired.",
    goToLogin: "Log in",
    newPassword: "New password",
    // Home sections
    latestProducts: "Our latest products",
    joinUs: "Join us",
    joinUsDesc: "Discover the world of",
    onYouTube: "on YouTube",
    visit: "Visit",
    faq: "FAQ",
    collectEmotion: "Collect the Emotion",
    flashSales: "Flash Sales",
    flashSalesDesc: "Limited offers, don't miss out!",
    collectionPremium: "The Collectors Hub",
    discover: "Discover",
    heroDesc: "Booster & Starter, Japanese Display, Exclusive Box... Find your next TCG treasure",
    boosterFree: "1 Free Booster!",
    boosterFreeDesc: "On your first order",
    claimOffer: "Claim my booster",
    ourLivesWhatnot: "Our Whatnot Lives",
    whatnotDesc: "Join our live sales on",
    whatnotCta: "Watch our lives",
    trustService: "Dedicated Support",
    trustServiceDesc: "Response within 24h",
    trustShipping: "Fast Shipping",
    trustShippingDesc: "Shipped within 48h",
    trustSponsoring: "Referral Program",
    trustSponsoringDesc: "€5 off for each friend",
    // Profile
    myProfile: "My profile",
    personalInfo: "Personal info",
    myAddresses: "My addresses",
    myOrders: "My orders",
    security: "Security",
    loyalty: "Loyalty",
    loyaltyProgram: "Loyalty program",
    perEuroSpent: "per €1 spent",
    perReview: "per review posted",
    pointsToDiscount: "points = €1 discount",
    noAddresses: "No saved addresses",
    addressSaved: "saved address",
    addressSaved_plural: "saved addresses",
    defaultAddress: "Default",
    ordersWillAppear: "Your orders will appear here",
    // Checkout
    firstName: "First name",
    lastName: "Last name",
    address: "Address",
    addressComplement: "Address line 2",
    city: "City",
    postalCode: "Postal code",
    country: "Country",
    phone: "Phone",
    securePayment: "100% secure payment",
    orderSummary: "Summary",
    subtotal: "Subtotal",
    discount: "Discount",
    promoCode: "Promo code",
    applyPromo: "Apply",
    pay: "Pay",
    qty: "Qty",
    // Order Confirmation
    paymentVerification: "Verifying payment...",
    orderConfirmed: "Order confirmed!",
    amountPaid: "Amount paid",
    // Recently viewed
    recentlyViewed: "Recently viewed",
    // Compare
    compare: "Compare",
    compareProducts: "Compare products",
    price: "Price",
    type: "Type",
    status: "Status",
    available: "Available",
    clearAll: "Clear all",
    // Footer
    newsletter: "Newsletter",
    newsletterDesc: "Get our exclusive offers",
    subscribe: "Subscribe",
    aboutUs: "About",
    aboutLinks: ["Our story", "Blog", "News", "Contact us"],
    infoTitle: "Information",
    infoLinks: ["Terms & Conditions", "Legal notices", "Terms of Use", "Privacy Policy", "Return Policy"],
    customerService: "Customer service",
    quickLinks: "Quick links",
    followUs: "Follow us",
    allRightsReserved: "All rights reserved",
    yourEmail: "Your email",
    footerLinks: ["Privacy", "Terms", "Shipping", "Contact"],
    language: "English",
    // Currency
    currency: "Currency",
    currencyLabel: "France (EUR €)",
    // Misc
    loading: "Loading...",
    error: "Error",
    back: "Back",
    apply: "Apply",
    save: "Save",
    delete: "Delete",
    close: "Close",
    min: "Min",
    max: "Max",
    newsletterPopupTitle: "Sign up and receive a",
    newsletterPopupSubtitle: "on your 1st order.",
    newsletterPopupDesc: "Subscribe to our newsletter and be the first to know about new arrivals, promotions and exclusives.",
  }
};

export default translations;
